import { HelpCircle } from 'lucide-react';

export function Topbar() {
	return (
		<div className="h-[60px] border-b bg-card flex items-center px-7 gap-4 sticky top-0 z-10">
			<div className="flex-1 text-[13px] text-muted-foreground">Canis Major control panel</div>
			<div className="ml-auto flex items-center gap-2">
				<span className="badge-pill tone-violet">Super admin</span>
				<button title="Help" className="h-[34px] w-[34px] border rounded-md grid place-items-center text-muted-foreground hover:bg-background hover:text-foreground">
					<HelpCircle className="h-[15px] w-[15px]" />
				</button>
			</div>
		</div>
	);
}
